import { render, staticRenderFns } from "./VentasEvento.vue?vue&type=template&id=5a86b364&v-if=evento"
import script from "./VentasEvento.vue?vue&type=script&lang=js"
export * from "./VentasEvento.vue?vue&type=script&lang=js"
import style0 from "./VentasEvento.vue?vue&type=style&index=0&id=5a86b364&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports